import styles from './SliderScore.module.css'
import clsx from 'clsx'
import { BasicStyledComponent } from 'shared-definitions/types'
import { useState } from 'react'
import Check from 'shared-svg/Check.svg'

interface SliderScoreProps extends BasicStyledComponent {
  score: number | null
  submitted: boolean
  onSubmit: (newVal: number) => void
}

const SliderScore: React.VFC<SliderScoreProps> = ({ onSubmit, className, score, submitted }) => {
  const [val, setVal] = useState(score === null ? 0 : Math.round(score))

  return (
    <div className={clsx(styles.container, className, { [styles.submitted]: submitted })}>
      {score === null ? '-' : score.toFixed(1)}
      <div className={styles.slider}>
        <button
          type="button"
          aria-label="Confirm selection"
          className={styles.confirmButton}
          onClick={() => onSubmit(val)}
        >
          <Check className={styles.confirmIcon} />
        </button>
        <input
          aria-label="Select your score"
          className={styles.input}
          type="range"
          min={1}
          max={10}
          step={1}
          value={val}
          onChange={e => setVal(parseFloat(e.target.value))}
        />
        {val.toFixed(1)}
      </div>
    </div>
  )
}

export default SliderScore
